import {SupportedLocales} from '#types';

export const datasetFormLang = {
  [SupportedLocales.EN]: {
    title: 'Dataset',
    createCaption: 'Create a new dataset for activating your data.',
    editCaption: 'Edit a dataset for working with your data.',
    loadError: 'The dataset form could not be loaded.',
    retry: 'Retry',
    created: 'Dataset created successfully',
    updated: 'Dataset updated successfully',
  },
  [SupportedLocales.ES]: {
    title: 'Conjunto de datos',
    createCaption: 'Crea un nuevo conjunto de datos para activar tus datos.',
    editCaption: 'Edita un conjunto de datos para trabajar con tus datos.',
    loadError: 'No se pudo cargar el formulario del conjunto de datos.',
    retry: 'Reintentar',
    created: 'Conjunto de datos creado correctamente',
    updated: 'Conjunto de datos actualizado correctamente',
  },
};
